module.exports = __webpack_public_path__ + "fonts/Rubik-Regular.cd619a4f.ttf";